<div class="totale container" [ngClass]="{'vedisx': toggle }">
    <div class="sinistra left">

         <mat-card class="ricerca">
            <mat-card-title>{{'Ricerca'|translate}}<a (click)="clickToggle()" class="aprisx"><i class="material-icons">&#xE5CD;</i></a></mat-card-title>
            <!--mat-card-subtitle>{{'Utilizza i criteri per cercare la macchina'|translate}}</mat-card-subtitle-->
              <form>
                <mat-input-container>
                    <input [(ngModel)]="descrizione" name="descrizione" matInput placeholder="{{'Cerca per macchina'|translate}}">
                </mat-input-container><br>
                <mat-input-container>
                    <input [(ngModel)]="matricola"  name="matricola" matInput placeholder="{{'Cerca per matricola'|translate}}">
                </mat-input-container><br>
                <button mat-raised-button color="bottonebianco" (click)="cercaMatricole()">{{'Cerca'|translate}}</button>
            </form>
        </mat-card> 
        <BR>
        <button mat-raised-button color="bianco" [routerLink]="['/richiestaGaranzia']" >{{'Compila una richiesta libera'|translate}}</button>
    </div>
    <div class="centro" style="min-height:500px;"><a mat-raised-button color="bianco" (click)="clickToggle()" class="aprisx"><i class="material-icons">&#xE8B6;</i></a>
        <nav>
            <ul class="nav-wrapper">
                <li><a mat-raised-button color="primary" [routerLink]="['/matricole']">{{'Garanzie'|translate}}</a></li>
            </ul>
        </nav><div class="corpo">
<div class="listamatricole">
    <mat-card class="matricole-macchina">
                <!--h3 class="titologriglia">Macchine in garanzia</h3-->
                <p *ngIf="ricerca">{{'Recupero dati in corso.'|translate}}</p>
                <div *ngIf="!ricerca && (matricole==undefined || matricole.length<1)">
                <p >{{'Nessuna macchina in garanzia trovata.'|translate}}</p>
                </div>
                <table class="mat-data-table" cellpadding="0" cellspacing="0"  *ngIf="matricole!=undefined && matricole.length>0 && !ricerca">
                    <thead>
                        <tr>
                            
                            <th class="mdl-data-table__cell--non-numeric">
                                <span>{{'Matricola'|translate}} </span>
                            </th>
                            <th class="mdl-data-table__cell--non-numeric">
                                <span>{{'Codice macchina'|translate}} </span>
                            </th>
                            <th class="mdl-data-table__cell--non-numeric">
                                <span>{{'Macchina'|translate}} </span>
                            </th>
                           
                            <th class="mdl-data-table__cell--non-numeric">
                                <span>{{'Data acquisto'|translate}} </span>
                            </th>
                            <th class=" mdl-data-table__cell--non-numeric">
                                <span>{{'Richiesta di garanzia'|translate}} </span>
                            </th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr grid-item  *ngFor="let r of matricole">
                            <td>{{r.codice}}</td>
                            <td>{{r.macchina.codice}}</td>
                            <td><a [routerLink]="['/scheda', r.macchina.id]">{{r.macchina.descrizione}}</a></td> 
                            <td>{{r.data}}</td>
                            <td><a *ngIf="r.garanzia" [routerLink]="['/richiestaGaranzia', r.id]"><i class="material-icons">&#xE254;</i></a>
                            
                        </tr>
                    </tbody>
                </table><br>


            </mat-card>
</div>
        </div></div>
</div>


// WEBPACK FOOTER //
// ./src/app/tws-matricole/tws-matricole.component.html